import * as React from 'react'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { Icon, IconType} from '@amzn/dvui/dist/Icon'
import { Container } from '@amzn/dvui/dist/Container'
import { Text } from '@amzn/dvui/dist/Text'
import { ICollection } from '../../selectors/collections'
import { CarouselCollection } from '../carousel/carouselCollection'
import * as st from './castAndCrew.module.scss'
import * as stUtility from '../utilityClasses.module.scss'
import { SrcSize } from '../../utils/imageUtils'
import { ResponsiveImage } from '../images/responsiveImage'
import { StringId } from '../localizer/stringId'
import { TextLocalizer } from '../localizer/localizer'
import * as cn from 'classnames'

const MEMBER_IMAGE_PHONE_LANDSCAPE_WIDTH = 112
const MEMBER_IMAGE_DEFAULT_WIDTH = 175

export interface ICastAndCrewProps {
  content?: WpsRuntime.atv.wps.CastAndCrewWidgetModelProps
}

const CastAndCrewRow = ({castMember, showCastImages, index}: {
  castMember: WpsRuntime.atv.wps.CastMemberModel,
  showCastImages: boolean,
  index: number
}) => {
  const collectionsProps = {
    collectionType: castMember.titleCollections.collectionType,
    cardTitleIds: castMember.titleCollections.cards.map(card => card.titleID),
    totalEpisodeSize: castMember.titleCollections.totalCardSize,
    index
  } as ICollection


  const getCastImage = (imageUrl?: string, personPageImageLink?: string) => {
    const imgProps = {
      alt: '',
      src: imageUrl,
      baseValue: MEMBER_IMAGE_DEFAULT_WIDTH,
      srcSizes: [
        { 'max-phone-landscape': MEMBER_IMAGE_PHONE_LANDSCAPE_WIDTH },
      ] as SrcSize[]
    }

    const isValidImage = imageUrl && imageUrl !== '\\N'

    const imageContent = <>
      <div className={st.noImage} >
        <Icon className={st.sash} use={IconType.LOGO_PRIMEVIDEO} />
      </div>
      {isValidImage && <ResponsiveImage className={st.castImage} {...imgProps}/>}
    </>

    return personPageImageLink ? <a href={personPageImageLink} className={'personPageImageLink'}> {imageContent} </a> : imageContent
  }

  const buildNameString = ( name: string, role?: string ) => role ? `${name} - ${role}` : name

  const { imageUrl, name, role, personPageLink, personPageImageLink } = castMember.cast

  return (
    <>
      <div className={st.nameRow}>
        <h3 className={st.name}>
          {buildNameString(name, role)}
        </h3>
        {personPageLink && <Text className={st.personPageLink} string={personPageLink} />}
      </div>
      <div className={cn(st.imageRow, "cast-and-crew-member", {[st.showCastImage]: showCastImages})}>
        {showCastImages &&
          <div className={`${st.castImageWrapper}`}>
            {getCastImage(imageUrl, personPageImageLink)}
          </div>}
        <CarouselCollection {...collectionsProps} />
      </div>
    </>
  )
}

export const CastAndCrew = ({ content }: ICastAndCrewProps) => {
  const castMemberList = content && content.castAndCrews

  if (castMemberList && castMemberList.length > 0) {
    // Show cast images if any cast has a image
    const showCastImages = castMemberList.some(member => (member.cast.imageUrl && member.cast.imageUrl !== '\\N'))

    return (
      <Container className={`${stUtility.pageSection} cast-and-crew-section`}>
        <h2 className={st.title}><TextLocalizer stringID={StringId.DV_DP_CAST_CREW_HEADING} /></h2>
        {castMemberList.map((castMember, idx) =>
          <CastAndCrewRow castMember={castMember} showCastImages={showCastImages} key={`cast-member-${idx}`} index={idx} />
        )}
      </Container>
    )
  } else {
    return null
  }
}
